import ExpandableWrapper from './ExpandableWrapper';

export default ExpandableWrapper;
